import React from 'react';
import { hasActiveManagerFilters } from '../utils/managerFilters';

const inputClass = 'w-full px-3 py-2 border border-gray-200 rounded-xl text-sm';
const selectClass = 'w-full px-3 py-2 border border-gray-200 rounded-xl text-sm bg-white';

const ManagerFilters = ({
  filters,
  onChange,
  onClear,
  totalCount,
  filteredCount,
}) => {
  const update = (key, value) => onChange({ ...filters, [key]: value });

  return (
    <div className="card mb-6">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div>
          <h2 className="text-sm font-semibold text-gray-900">Filters</h2>
          <p className="text-xs text-gray-500 mt-0.5">
            Showing {filteredCount} of {totalCount} managers
          </p>
        </div>
        {hasActiveManagerFilters(filters) && (
          <button
            type="button"
            onClick={onClear}
            className="text-sm text-gray-600 hover:text-gray-900 px-3 py-1.5 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Clear filters
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="lg:col-span-2">
          <label className="block text-xs font-medium text-gray-600 mb-1">Search</label>
          <input
            type="text"
            value={filters.search}
            onChange={(e) => update('search', e.target.value)}
            className={inputClass}
            placeholder="Manager name or email"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
          <select
            value={filters.status}
            onChange={(e) => update('status', e.target.value)}
            className={selectClass}
          >
            <option value="">All statuses</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Added From</label>
          <input
            type="date"
            value={filters.dateFrom}
            onChange={(e) => update('dateFrom', e.target.value)}
            className={inputClass}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Added To</label>
          <input
            type="date"
            value={filters.dateTo}
            onChange={(e) => update('dateTo', e.target.value)}
            className={inputClass}
          />
        </div>
      </div>
    </div>
  );
};

export default ManagerFilters;
